export default "__VITE_ASSET__Ch1ea_OS__"